import React, { Component, type ReactNode } from "react";

interface ApplicationErrorBoundaryState {
  failed: boolean;
}

export class ApplicationErrorBoundary extends Component<
  { children: ReactNode },
  ApplicationErrorBoundaryState
> {
  public override state: ApplicationErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ApplicationErrorBoundaryState {
    return { failed: true };
  }

  public override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="fatal-error-page">
        <header className="site-header fatal-error-header">
          <div className="container header-inner">
            <a className="brand" href="/">
              STANCEKIT
            </a>
          </div>
        </header>
        <main id="main-content" className="fatal-error-main">
          <div className="container narrow">
            <p className="kicker">Application error</p>
            <h1>This page could not be displayed.</h1>
            <p>
              Reload the page to try again. If the problem continues, return to
              the StanceKit home page.
            </p>
            <div className="button-row">
              <button
                className="button"
                onClick={() => window.location.reload()}
              >
                Reload page
              </button>
              <a className="button button-ghost" href="/">
                Return home
              </a>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
